const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_APP_SETTING':
      return {...state, [action.setting.NAME]: action.setting}
    case 'SET_APP_SETTINGS':
      return {...state, ...action.settings}
    default:
      return state
  }
}
